import { css } from 'styled-components';

export const SupportPopup = css(({ theme }) => {
  return css`
    > .popup-content {
      padding: 8px;
      text-align: center;

      > .row {
        font-weight: 500;
        margin-bottom: 5px;
        font-size: 18px;
        line-height: 32px;
      }
    }

    > .dialog-title {
      font-size: 25px;
      font-weight: 600;
      line-height: 36px;
    }
  `;
});
